import { useNavigate } from 'react-router-dom'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center px-4">
      <div className="text-center animate-fade-in">
        <div className="text-7xl mb-6 opacity-20">♚</div>
        <h1 className="font-display text-4xl font-bold text-ivory-50 mb-3">404</h1>
        <p className="text-ivory-300/50 mb-8">This page doesn't exist.</p>
        <button onClick={() => navigate('/')} className="btn-secondary">
          ← Back to Home
        </button>
      </div>
    </div>
  )
}
